import { render, staticRenderFns } from "./GvsCardStatus.vue?vue&type=template&id=f55f8ed0&scoped=true&"
import script from "./GvsCardStatus.vue?vue&type=script&lang=js&"
export * from "./GvsCardStatus.vue?vue&type=script&lang=js&"
import style0 from "./GvsCardStatus.vue?vue&type=style&index=0&id=f55f8ed0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55f8ed0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
